module.exports = __webpack_public_path__ + "img/login.a426979e.png";